module.exports = __webpack_public_path__ + "img/Twitter.80b13013.jpg";